import {
  Anchor,
  Button,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  TypographyStylesProvider,
} from "@mantine/core";
import { IconCircleDashedCheck, IconClock } from "@tabler/icons-react";
import React from "react";

import { Cubby } from "../../stores/Cubby";
import NodeStatus from "../articlesHelpers/NodeStatus";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";

export const NODE_STATUS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      A Lightning Node can hold and transfer Bitcoin. If you turn a Lightning
      Node off, and then turn it back on again, all your funds will still be
      there.
    </p>

    <p>
      But: In order to send and receive Lightning payments, the node needs to be
      online 24/7.
    </p>
    <p>
      Really: We're serious here. Incoming payments will actually{" "}
      <strong>fail</strong> if your node is offline.
    </p>
    <p>
      This is one reason that Rizful Node runs "in the cloud" -- trying to run a
      Lightning Node on a home computer, which might have an unstable internet
      connection, or might sometimes be turned off, is a recipe for frustration.
    </p>

    <p>
      In any case, it's important for you to know what status your Rizful node
      is in.
    </p>

    <Stack>
      <DocsHighlightCard>
        <NodeStatus status="running" />
        <p>
          <strong>Running:</strong> This status means that your node is fully
          operational. If you have any open Lightning channels, you'll be able
          to send and/or receive payments.
        </p>
      </DocsHighlightCard>

      <DocsHighlightCard>
        <NodeStatus status="stopped" />
        <p>
          <strong>Stopped:</strong> If you don't send or receive payments for a
          while -- typically a few days -- your node will stop. (Unless you've
          paid for "guaranteed uptime", see below for more about that.)
        </p>
        <p>
          If your node is stopped, you'll need to start it again to get back to
          running status. While your node is stopped, your funds are safe, but
          you won't be able to send or receive payments.
        </p>
        <p>
          If your node is stopped for a long time, one of your channel partners
          (other nodes that you have channels with) might decide to close your
          channel. If they do close your channel at this time, your funds will
          "settle" or "revert" to the BTC balance in your wallet within a few
          days.
        </p>
      </DocsHighlightCard>

      <DocsHighlightCard>
        <NodeStatus status="starting_up" />
        <p>
          <strong>Starting Up:</strong> When you first launch Rizful, your node
          will be available <em>instantly</em>, with no start-up delay.
        </p>

        <p>
          But if your node is automatically stopped after a period of
          inactivity, when you don't have "guaranteed uptime" enabled, then when
          you next load the node in your browser, you'll need to manually start
          it. Then, the node will go into the "starting up" status.
        </p>
        <p>
          A node startup can take a variable amount of time, while the node
          synchronizes with the Lightning Network. The exact length of time{" "}
          <em>is kind of hard to predict</em>. Under certain network conditions,
          this can take a long time, like up to thirty minutes. But if you keep
          your node running, you might never see this status.
        </p>
      </DocsHighlightCard>
    </Stack>
  </TypographyStylesProvider>
);
